import { useIsMobileApp } from './useIsMobileApp';

export const useIsAuthorizedRouteForSecondFactorRecommendation = () => {
  const { isIosApp } = useIsMobileApp();

  return !isIosApp;
};
